import moment from 'moment';

function ActiveIntegrationsTimeRangeFilters({
  queryStartDate,
  setQueryStartDate,
}) {
  const timeRanges = [
    { label: 'Last 7 Days', startDate: dateRangeStartDate(-7, 'day') },
    { label: 'Last 14 Days', startDate: dateRangeStartDate(-14, 'day') },
    { label: 'Last 30 Days', startDate: dateRangeStartDate(-30, 'day') },
    { label: 'Last Year', startDate: dateRangeStartDate(-1, 'year') },
  ];
  return (
    <div className="flex flex-row py-2 mb-2 text-base font-medium text-gray-600">
      <div className="flex flex-col flex-start">Show data for:</div>
      <div className="flex flex-col grow">
        <div className="flex flex-row ">
          {timeRanges.map((x) => {
            return (
              <div
                key={x.label}
                className={`mx-2 flex rounded ${
                  moment(x.startDate).isSame(queryStartDate, 'day')
                    ? 'bg-blue-400 text-white'
                    : ''
                }  flex-row  grow `}>
                <div
                  className={`${
                    x.label == 'All Time' ? 'border-l-2 border-gray-200' : ''
                  } flex flex-col justify-center text-center w-full`}
                  onClick={() => setQueryStartDate(x.startDate)}>
                  {x.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
function dateRangeStartDate(amountToAdd, unit) {
  return moment().add(amountToAdd, unit);
}

export default ActiveIntegrationsTimeRangeFilters;
